import { defineMessages } from 'react-intl';

const messages = defineMessages({
  placeholder: {
    id: 'mobileListSearchBar.placeholder',
    defaultMessage: 'Dossiers, commandes, tracking, client…',
  },
  scanAriaLabel: {
    id: 'mobileListSearchBar.scanAriaLabel',
    defaultMessage: 'Scanner un code-barres',
  },
});

export default messages;
